export type AppError = { code?: string; error: string };

export function adaptSupabaseError(e: any): AppError {
  const msg = e?.message || String(e || 'Unknown');
  const code = e?.code || '';
  const hint = e?.hint || '';
  const details = e?.details || '';

  // Log completo para debugging
  console.error('Supabase Error Details:', {
    message: msg,
    code,
    hint,
    details,
    fullError: e,
  });

  if (/Failed to fetch|Network|ERR_NETWORK|TypeError: fetch/i.test(msg))
    return {
      code: 'NETWORK',
      error: 'Sin conexión con el servicio. Inténtalo de nuevo.',
    };

  // permisos / RLS
  if (/permission denied|401|403|RLS|policy/i.test(msg))
    return {
      code: 'FORBIDDEN',
      error:
        `No tienes permisos para esa operación. ${hint || details || ''}`.trim(),
    };

  // recurso inexistente
  if (/PGRST116|No rows found/i.test(msg))
    return {
      code: 'NOT_FOUND',
      error: 'No se encontró la información solicitada.',
    };

  // validación
  if (/invalid input|violates|constraint/i.test(msg))
    return { code: 'VALIDATION', error: 'Datos inválidos o incompletos.' };

  // config supabase
  if (/Invalid API key|Project not found/i.test(msg))
    return {
      code: 'CONFIG',
      error: 'Configuración de base de datos inválida.',
    };

  // Retornar el error completo de Supabase para debugging
  const fullError = `${msg}${hint ? ` (${hint})` : ''}${details ? ` - ${details}` : ''}`;
  return {
    code: code || 'UNKNOWN',
    error: fullError || 'Ocurrió un error. Intenta de nuevo.',
  };
}
